import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ProgressBar from 'ui-library/bs/ProgressBar';
import * as Colors from 'ui-library/Colors';
import {formatThousands} from 'util/NameUtil';

import {ProcessingSummaryStatistics} from './LabAutomationConstants';

const FAILED_MESSAGE_SUFFIX = 'skipped due to errors.';
interface AutomationFileProgressBarInterface {
  processingSummaryStatistics: ProcessingSummaryStatistics;
}

function _formatNumRowsFailedMessage(numRowsFailed: number): string {
  const messagePrefix = formatThousands(numRowsFailed);
  let messageRoot = '';
  if (numRowsFailed === 1) {
    messageRoot += ' row was ';
  } else {
    messageRoot += ' rows were ';
  }
  return messagePrefix + messageRoot + FAILED_MESSAGE_SUFFIX;
}

function AutomationFileProgressBar(props: AutomationFileProgressBarInterface): JSX.Element | null {
  const numRowsFailedMessage = _formatNumRowsFailedMessage(props.processingSummaryStatistics.numRowsFailed);
  return (
    <>
      <div className={css(styles.progressBarWrapper)}>
        <ProgressBar
          className={css(styles.progressBar)}
          value={props.processingSummaryStatistics.percentOfRowsProcessed}
          type="success"
        />
        <div className={css(styles.percentText)}>
          {props.processingSummaryStatistics.percentOfRowsProcessed}%
        </div>
      </div>
      <div>
        <p className={css(styles.summaryText)}>
          {formatThousands(props.processingSummaryStatistics.numRowsProcessed)} out of{' '}
          {formatThousands(props.processingSummaryStatistics.totalRows)} rows processed so far.
        </p>
        <p className={css(styles.errorText)}>{numRowsFailedMessage}</p>
      </div>
    </>
  );
}

const styles = StyleSheet.create({
  progressBar: {
    height: '12px',
    width: '100%',
    marginBottom: '8px',
  },
  progressBarWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
    alignItems: 'flex-start',
  },
  percentText: {
    marginLeft: '11px',
  },
  summaryText: {
    margin: 0,
  },
  errorText: {
    color: Colors.RED,
  },
});

export default AutomationFileProgressBar;
